
import { TypedVue } from "@/store/types";
import { Component, Prop, Ref, Watch } from "vue-property-decorator";
import { Modal } from "bootstrap";
import { systemAPI } from "@/lib/s3PlatformApi";

@Component({})
export default class CreateOrganizationModal extends TypedVue {
  @Ref("create-org-modal")
  readonly modal!: Modal;

  @Prop()
  show!: boolean;

  orgName = "";

  errorText = "";
  isSaving = false;

  @Watch("show")
  onShowChange(show: boolean) {
    if (show) {
      this.modal.show();
    } else {
      this.modal.hide();
    }
  }

  get shortOrgName(): string {
    const normalized = this.orgName
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, "") // remove punctuation
      .replace(/\s+/g, "-") // spaces → hyphens
      .replace(/-+/g, "-");

    if (normalized.length > 50) {
      return normalized.substring(0, 50);
    }

    return normalized;
  }

  createOrganization(): void {
    this.isSaving = true;
    this.errorText = "";

    systemAPI
      .createOrganization({
        displayName: this.orgName,
        name: this.shortOrgName,
      })
      .then(async (response) => {
        const org_id = response.data.id;
        await this.$auth.getTokenSilently({ organization: org_id, ignoreCache: true });

        localStorage.clear();
        await this.$router.go(0);
      })
      .catch(() => {
        this.errorText = "Error creating organization. Please try again later.";
      })
      .finally(() => {
        this.isSaving = false;
        this.close();
      });
  }

  close(): void {
    this.orgName = "";
    this.errorText = "";
    this.isSaving = false;
    this.$emit("close");
  }
}
